<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-dialog-content class="mat-typography">
    <h3>{{data.message}}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">{{data.actionLabels.no}}</button>
    <button mat-button [mat-dialog-close]="true">{{data.actionLabels.yes}}</button>
</mat-dialog-actions>
